import React from 'react';
import { number, string, func, arrayOf } from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';
import { userConnectionPropTypes } from '../../../sharedPropTypes';
import UserActionFollowCard from '../../cards/actionCards/UserActionFollowCard';
import ActionCardListBase from '../ActionCardListBase';

const ActionCardFindFriendsList = ({ header, truncateLimit, className, handleViewAllClick, userConnections }) => {
  const { languageRegionCode } = useSelector(state => state.context, shallowEqual);

  return (
    <ActionCardListBase header={header} truncateLimit={truncateLimit} className={className} handleViewAllClick={handleViewAllClick}>
      {userConnections.map(userConnection => {
        return <UserActionFollowCard key={userConnection.user.id} userConnection={userConnection} languageRegionCode={languageRegionCode} />;
      })}
    </ActionCardListBase>
  );
};

ActionCardFindFriendsList.propTypes = {
  header: string,
  truncateLimit: number,
  className: string,
  handleViewAllClick: func,
  userConnections: arrayOf(userConnectionPropTypes).isRequired
};

ActionCardFindFriendsList.defaultProps = {
  header: null,
  truncateLimit: null,
  className: '',
  handleViewAllClick: null
};

export default ActionCardFindFriendsList;
